import React from 'react';

// The four decision types every object-detail documentation form offers —
// order, wording and colors match the approved design exactly:
// Accepteret risiko (blue), Skal rettes (orange), Kompenserende kontrol
// (turquoise), Falsk positiv (grey) — see the --decision-* tokens in
// index.css and .decision-type-btn--* in styles.css. `temp` keeps its old
// key (it was "Undtagelse") so notes already saved under it still read; it now means
// "Skal rettes": the owner and the date on the note are who fixes it and by when.
export const DECISION_TYPES = [
  ['accepted', 'Accepteret risiko'],
  ['temp', 'Skal rettes'],
  ['compensating', 'Kompenserende kontrol'],
  ['falsepos', 'Falsk positiv'],
];
// "resolved" ("Løst") isn't offered as a button any more, but a handful of
// notes may already be saved under it — kept here so those still show a
// real label instead of falling back to "Dokumenteret".
const LEGACY_DECISION_LABELS = { resolved: 'Løst' };
export const DECISION_LABEL = { ...LEGACY_DECISION_LABELS, ...Object.fromEntries(DECISION_TYPES) };

// The icon-chip treatment every Dokumentation form uses (Arbejdskø's own inline form in
// WorkQueuePage.jsx, and the shared DocumentationPanel used by Compliance/Konfiguration) — kept here,
// next to DECISION_TYPES, so both stay pixel-identical instead of drifting into two different looks.
export const ICON_PROPS = { viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: 2, strokeLinecap: 'round', strokeLinejoin: 'round' };

export function DecisionIcon({ kind }) {
  if (kind === 'accepted') return <svg {...ICON_PROPS}><path d="M12 3l7 3v5c0 5-3 8-7 10-4-2-7-5-7-10V6z" /><path d="M9 12l2 2 4-4" /></svg>;
  if (kind === 'temp') return <svg {...ICON_PROPS}><circle cx="12" cy="12" r="9" /><path d="M12 7v5l3 2" /></svg>;
  if (kind === 'compensating') return <svg {...ICON_PROPS}><path d="M12 3l9 5-9 5-9-5 9-5z" /><path d="M3 13l9 5 9-5" /></svg>;
  return <svg {...ICON_PROPS}><circle cx="12" cy="12" r="9" /><path d="M9 9l6 6M15 9l-6 6" /></svg>;
}

// Same colored-button treatment as Fund's own decision-type picker
// (ArbejdskoPage.jsx's .decision-type-grid) — clicking the active button
// again clears the selection, matching that behavior exactly.
export default function DecisionTypeRadios({ value, onChange, disabled }) {
  return (
    <>
      <label>Beslutningstype</label>
      <div className="decision-type-grid">
        {DECISION_TYPES.map(([key, label]) => (
          <button
            type="button"
            key={key}
            className={`decision-type-btn decision-type-btn--${key}${value === key ? ' is-selected' : ''}`}
            onClick={() => onChange(value === key ? '' : key)}
            disabled={disabled}
          >
            {label}
          </button>
        ))}
      </div>
    </>
  );
}
